export const BATCH_MANAGER_ENDPOINT = '/csds/collector/v1/events/batch';
export const DEFAULT_TIMEOUT_MILLIS = 6000;
export const INTERNAL_SERVER_ERROR = 500;
